import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { RootState } from "../../state";
import { Country } from "../../common/actions/Auth";

export type TranslateFunction = (id: string, values?: { [key: string]: any }) => string;

interface LocaleContext {
  translate: (id: string, values?: { [key: string]: any }) => string;
  locale: string;
  country: Country;
}

interface MappedProps {
  country: Country;
}

interface RenderProps extends MappedProps {
  children: (props: LocaleContext) => React.ReactElement<any> | null;
}

const WithLocale: React.SFC<RenderProps> = ({ children: render, country }, _context) => {
  const context = _context as LocaleContext;
  return render({ ...context, country });
};
WithLocale.contextTypes = {
  translate: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
} as PropTypes.ValidationMap<LocaleContext>;

function mapStateToProps(state: RootState): MappedProps {
  return {
    country: state.auth.country,
  };
}

export default connect(mapStateToProps)(WithLocale);



// WEBPACK FOOTER //
// ./frontend/src/common/components/WithLocale.tsx